window.pageOpen="true";
document.addEventListener("DOMContentLoaded", function () {
    window.customTranslation = function() { 
        console.log('WOPOF app found');
        let cart_transl = JSON.stringify({ orders_text:"mijn bestellingen", prev_page:"Vorig",limit_text:"",hide_stock:true,cart_empty:"Winkelwagen is leeg", hide_variantSelectors:true, is_hide_filters:false,shop_now:"Nu winkelen",checkout:"Afrekenen" , your_cart:"Uw winkelwagen" , in_stock:"Op voorraad" ,out_of_stock:"Uitverkocht",load_more:"laad meer",
        items:"artikelen",total:"Totaal",add_to_cart:"In winkelwagen",adding:"Toevoegen",cart_added_txt:"Product succesvol toegevoegd",collection_filter_title:"Collecties" ,
        search_text:"Typ in",search_title:"Zoeken", title_text : "Titel",sku_text : "SKU", 
        tags_text : "Labels" });
        document.querySelector("#wopof-app").setAttribute("data-collection_title","Collecties")
        document.querySelector("#wopof-app").setAttribute("data-cart_transl", cart_transl);
    }

    function updateCartBubble(cartCnt) {
        let bubble = document.querySelector('.cart-icon--basket1 > div');
        console.log("bubble::",bubble)
        bubble.textContent = cartCnt;
    }
    window.dcCartCallBack = async (item)=>{
        console.log("Add cart Callback MST::", item)
        const cart = await fetch('/cart.js').then(r => r.json());
        document.querySelector('#wopof_cart_cnt').innerHTML = cart.item_count;
        updateCartBubble(cart.item_count);
        //window.location.href = "/cart"
    }
    document.addEventListener('click',function (e) {
        const btn = e.target.closest('.cart');
        if (!btn) return;
        window.location.href="/cart"
    })
})